import { Injectable } from '@angular/core';
import { StorageService } from '../storage/storage.service';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { ClientAccount, UserMetadata } from 'src/app/models/UserMetadata';
import { BYPASS_INTERCEPTOR, SHOW_API_ERROR_DIALOG } from '../interceptor/interceptor.interceptor';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CoreService {
  constructor(private storageService: StorageService, private http: HttpClient, private router: Router) { };

  callPostApi(apiPath: string, body: any, bypassInterceptor: boolean = false, showApiErrorDialog: boolean = false): Observable<any> | any {
    const userMetadata: UserMetadata = this.storageService.getItem('user_metadata');
    const currentClient: ClientAccount = this.storageService.getItem('current_client');

    if(userMetadata && userMetadata.access_token){
      return this.http.post(`${environment.CORE_URL}${environment.name !== 'local' ? `/${currentClient.unique_key}` : ''}/${apiPath}`, body, {
        headers: {
          'Authorization': `Bearer ${userMetadata.access_token}`,
          'x-api-key': currentClient.x_api_key ?? '',
        },
        context: new HttpContext().set(BYPASS_INTERCEPTOR, bypassInterceptor).set(SHOW_API_ERROR_DIALOG, showApiErrorDialog)
      });
    }

    this.storageService.clear();
    this.router.navigateByUrl('/login');
  }

  callGetApi(apiPath: string, params: any = null, bypassInterceptor: boolean = false, showApiErrorDialog: boolean = false): Observable<any> | any {
    const userMetadata: UserMetadata = this.storageService.getItem('user_metadata');
    const currentClient: ClientAccount = this.storageService.getItem('current_client');

    if(userMetadata && userMetadata.access_token){
      return this.http.get(`${environment.CORE_URL}${environment.name !== 'local' ? `/${currentClient.unique_key}` : ''}/${apiPath}`, {
        params: params,
        headers: {
          'Authorization': `Bearer ${userMetadata.access_token}`,
          'x-api-key': currentClient.x_api_key ?? '',
        },
        context: new HttpContext().set(BYPASS_INTERCEPTOR, bypassInterceptor).set(SHOW_API_ERROR_DIALOG, showApiErrorDialog)
      });
    }

    this.storageService.clear();
    this.router.navigateByUrl('/login');
  }

}
